<template>
  <div class="takt-journal-day-overview-content">
    <div
      class="takt-journal-day-overview-content-header"
      >
      <slot name="header"/>
    </div>
    <div
      class="takt-journal-day-overview-content-body"
      :style="justify_body?`align-items: ${justify_body}`:''"
      >
      <slot name="body"/>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['justify_body']
  }
</script>
<style>
  .takt-journal-day-overview-content {
    border-bottom: solid 1px #9E9E9E;
    page-break-inside: avoid;
  }
  .takt-journal-day-overview-content-header {
    display: flex;
    font-size: 4mm;
    margin-top: 1mm;
  }
  .takt-journal-day-overview-content-body {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .takt-journal-day-overview-content-work-packages {
    display: flex;
    align-items: flex-start;
    margin-bottom: 3px;
    /* max-height: 100px;
    overflow: auto; */
  }

</style>
